import React from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope, faUser } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import { useRef } from "react";
import "animate.css";
import software from "./software.svg";
import software1 from "./software1.svg";
import ux from "./ux.svg";
import ux1 from "./ux1.svg";
import plan from "./plan.svg";
import plan1 from "./plan1.svg";
import "./Home.css";
import Video from "./Video.mp4";
import Technolo from "../Technolo/Technolo";
// import Logoeg from "./Logoeg.png";

function Home() {
  const buttonStyle = {
    animationIterationCount: "15",
  };

  const [inViewport, setInViewport] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const image = document.getElementById("my-image");
      console.log(image);

      const imageRect = image.getBoundingClientRect();

      const windowHeight = window.innerHeight;

      const isImageInViewport =
        imageRect.bottom > 0 && imageRect.top < windowHeight;

      setInViewport(isImageInViewport);
    };

    window.addEventListener("scroll", handleScroll);
    return () =>
      window.removeEventListener("scroll", handleScroll, console.log("listen"));

    // animation
  }, []);

  const imageRef = useRef(null);
  const [scrolledPast, setScrolledPast] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const imageOffset = imageRef.current.getBoundingClientRect().top;
      if (imageOffset <= window.innerHeight * 0.8) {
        setScrolledPast(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const videoRef = useRef(null);

  // contact formspree
  const [Companyname, setName] = useState("");
  const [Fullname, setFullname] = useState("");
  const [Email, setEmail] = useState("");
  const [Message, setMessage] = useState("");
  const [Phone, setPhone] = useState("");
  const [custom, setcustom] = useState("");
  const [ui, setui] = useState("");
  const [consulting, setconsulting] = useState("");
  const [refferal, setrefferal] = useState("");
  const [blog, setblog] = useState("");
  const [facebook, setfacebook] = useState("");
  const [yelp, setyelp] = useState("");
  const [twitter, settwitter] = useState("");
  const [Other, setother] = useState("");
  const [LinkedIn, setlinkedIn] = useState("");
  const [Google, setGoogle] = useState("");
  const [googlead, setgooglead] = useState("");
  const [Meetup, setMeetup] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    try {
      await axios.post("https://formspree.io/f/meqwlroz", formData);
      // alert("Form submitted successfully");
      const notify = () => toast("Your form has been submitted sucessfully! ");
      setName("");
      setFullname("");
      setEmail("");
      setMessage("");
      setPhone("");
      setcustom("");
      setui("");
      setconsulting("");
      setGoogle("");
      setgooglead("");
      setGoogle("");
      setMeetup("");
      setblog("");
      setrefferal("");
      setyelp("");
      settwitter("");
      setother("");
      setlinkedIn("");
      setfacebook("");

      notify();
    } catch (error) {
      toast("Your form has not been submitted check the inputs  ");
    }
  };

  return (
    <div>
      <ToastContainer position="top-center" theme="light" />
      <div className="bg-video ">
        <video
          poster="Contact.jpg"
          ref={videoRef}
          autoPlay
          // controls
          loop
          muted
          preload="auto"
          className="bg-video__content"
        >
          <source src={Video} type="video/mp4" />
        </video>
        <div className="content">
          <div className="flex flex-row items-center justify-center my-5">
            <h1 className="cr text-transparent font-serif text-5xl font-bold leading-tight text-white animate-typewriter">
              Software Crafted by Top-Notch Engineers
            </h1>
          </div>

          <div className=" flex items-center justify-center w-full space-x-4 lg:space-x-20 ">
            <button className="text-white ">
              <img className="software" src={software} alt="SVG logo " />
              <h4 class="cs font-bold lg:text-2xl mt-0 mb-2 text-white">
                Custom Software
              </h4>
              <h4 class="wm font-large text-base mt-0 mb-2 text-white">
                Web & Mobile Apps
              </h4>
            </button>
            <button className="text-white">
              <img className="ux" src={ux} alt="SVG logo " />
              <h4 class="ux font-bold lg:text-2xl mt-0 mb-2 text-white">
                UI/UX Design
              </h4>
              <h4 class="pu font-large leading-tight text-base mt-0 mb-2 text-white">
                Protyping & User Testing
              </h4>
            </button>
            <button className="text-white">
              <img className="plan" src={plan} alt="SVG logo " />
              <h4 class="ca font-bold lg:text-2xl mt-0 mb-2 text-white">
                Consulting
              </h4>
              <h4 class="ap font-large leading-tight text-base mt-0 mb-2 text-white">
                Architecture & Planning
              </h4>
            </button>
          </div>
          <div className="flex flex-col items-center ">
            <br></br>

            <br></br>
            <br></br>
            <Link
              to="./Contact"
              spy={true}
              smooth={false}
              offset={-90}
              duration={900}
            >
              <button
                className="animate__animated animate__flash w-full h-10 rounded-md text-lime-100"
                style={buttonStyle}
              >
                BOOK FREE CONSULTATION
              </button>
            </Link>
            <br></br>
          </div>
        </div>
      </div>

      {/* </VideoBackground> */}

      <div className="bg-black">
        <div className="flex lg:flex-row flex-col lg:gap-8 sm:gap-10 gap-12 mx-3">
          <div className="md:max-w-xl lg:max-w-3xl mx-5">
            <h2 className="font-bold leading-tight text-3xl mb-2 text-gray-200">
              Our forte is in creating visually appealing and functional
              applications that are highly favored by users.
            </h2>
            <p className="mb-3 font-light text-gray-500 dark:text-gray-400 first-line:uppercase first-line:tracking-widest first-letter:text-7xl first-letter:font-bold first-letter:text-gray-200 dark:first-letter:text-gray-700 first-letter:mr-3 first-letter:float-left">
              We follow a meticulous and well-established design and development
              process to ensure that the features we integrate into your app
              align perfectly with your requirements. Our approach to crafting
              digital experiences is based on Google's tried and tested Material
              Design specification, which is the leading design standard for the
              web.
              <br></br> <br></br>
              <p className="text-blue-500">VIEW OUR CONSULTING SOLUTIONS</p>
            </p>
          </div>
          <div>
            <button className="text-white">
              <h4 class="font-bold leading-tight md:text-2xl lg:text-5xl mt-0 mb-2 text-gray-200">
                UI/UX Design
              </h4>
              <h4 class="font-bold leading-tight text-2xl mt-0 mb-2 text-gray-200">
                Prototyping & User Testing
              </h4>

              <img
                id="my-image"
                src={ux1}
                alt="SVG logo "
                className={` img-fluid ${
                  inViewport ? "animate__animated animate__fadeInRightBig" : ""
                }`}
              />
            </button>
          </div>
        </div>
      </div>

      <div className="bg-black ">
        <div className="flex lg:flex-row flex-col lg:gap-8 sm:gap-10 gap-12 mx-3">
          <button className="text-white">
            <h4 class="font-bold leading-tight md:text-2xl lg:text-5xl mt-0 mb-2 text-gray-200">
              Software Consulting
            </h4>
            <h4 class="font-bold leading-tight text-2xl mt-0 mb-2 text-gray-200">
              Architecture & Planning
            </h4>

            <img
              src={plan1}
              alt="SVG logo "
              id="my-image"
              className={`img-fluid ${
                inViewport ? "animate__animated animate__fadeInLeftBig" : ""
              }`}
            />
          </button>
       
        <div className="w-full lg:w-6/12">
          <h2 className="font-bold leading-tight text-3xl mt-0 mb-2 text-gray-200">
            We have a highly experienced team of technical experts with diverse
            skills and expertise.
          </h2>
          <p className="mb-3 font-light text-gray-500 dark:text-gray-400 first-line:uppercase first-line:tracking-widest first-letter:text-7xl first-letter:font-bold first-letter:text-gray-200 dark:first-letter:text-gray-700 first-letter:mr-3 first-letter:float-left">
            Our software consulting services encompass a wide range of offerings
            that cater to our clients' specific needs. These include, but are
            not limited to, intricate system architecture, development
            operations and strategy, product roadmapping, and outsourced CTO
            services.
            <br></br> <br></br>
            <p className="text-blue-500">VIEW OUR CONSULTING SOLUTIONS</p>
          </p>
        </div>
        </div>
      </div>

      <div className=" bg-black  ">
        <div className="flex lg:flex-row flex-col lg:gap-8 sm:gap-10 gap-12 mx-3">
          <div className="md:max-w-xl lg:max-w-3xl mx-5">
            <h2 className="font-bold leading-tight text-3xl mb-2 text-gray-200">
            Our focus is on creating and developing applications that are highly
            appreciated by users.
            </h2>
            <p className="mb-3 font-light text-gray-500 dark:text-gray-400 first-line:uppercase first-line:tracking-widest first-letter:text-7xl first-letter:font-bold first-letter:text-gray-200 dark:first-letter:text-gray-700 first-letter:mr-3 first-letter:float-left">
            We have crafted numerous tailor-made applications for various
            industries, including ShowUp's mobile applications and EasyGhar' web
            applications, to tackle a wide range of business obstacles.
              <br></br> <br></br>
              <p className="text-blue-500">VIEW OUR CONSULTING SOLUTIONS</p>
            </p>
          </div>
          <div>
            <button className="text-white">
              <h4 class="font-bold leading-tight md:text-2xl lg:text-5xl mt-0 mb-2 text-gray-200">
              Custom Software
              </h4>
              <h4 class="font-bold leading-tight text-2xl mt-0 mb-2 text-gray-200">
              Web & Mobile apps.
              </h4>

              <img
                id="my-image"
                src={software1}
                alt="SVG logo "
                className={` img-fluid ${
                  inViewport ? "animate__animated animate__fadeInRightBig" : ""
                }`}
              />
            </button>
          </div>
        </div>
      </div>

     

      {/* <Technolo></Technolo> */}

      {/* this would be the play book div
          <div className="playbook bg-auto sm:bg-cover md:bg-contain lg:bg-auto xl:bg-cover"> 
sjvbjsbveifbj
          </div> */}

      {/* contact page  */}

      <div className="fd" id="contact">
        <div className=" flex flex-row items-center justify-center ">
          <h1 class="font-bold leading-tight text-1xl mt-0 mb-2 text-gray-100 ">
            Let's have a talk
          </h1>
        </div>
        <div className="text-center">
          <h6 className="font-serif font-bold text-green-500 mt-1 mb-2">
            We would love to hear about your project.
          </h6>
          <p className="font-sans font-bold text-gray-200 mb-4 text-sm  animate-pulse">
            Our engagements begin at a minimum of{" "}
            <span className="text-green-500">$299</span>{" "}
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className=" flex justify-center ">
            <div>
              <div class="relative mb-3 xl:w-96">
                <FontAwesomeIcon
                  icon={faBriefcase}
                  className="flex flex-col"
                  color="white"
                  height="50px"
                  width="50px"
                />

                <input
                  type="text"
                  class="border peer m-0 block h-[58px] w-full rounded bg-transparent bg-clip-padding py-4 px-3 text-base font-normal leading-tight text-gray-200 ease-in-out placeholder:text-transparent focus:border-primary focus:bg-white focus:pt-[1.625rem] focus:pb-[0.625rem] focus:text-gray-200 focus:shadow-te-primary focus:outline-none [&:not(:placeholder-shown)]:pt-[1.625rem] [&:not(:placeholder-shown)]:pb-[0.625rem]"
                  id="floatingCompanyname"
                  required
                  placeholder="Companyname"
                  name="Companyname"
                  value={Companyname}
                  onChange={(e) => setName(e.target.value)}
                />
                <label
                  for="floatingCompanyname"
                  class="pointer-events-none absolute top-0 left-0 origin-[0_0] py-4 px-3 text-gray-200 transition-[opacity,_transform] duration-100 ease-in-out peer-focus:translate-x-[0.15rem] peer-focus:-translate-y-2 peer-focus:scale-[0.85] peer-focus:opacity-[0.65] peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:scale-[0.85] peer-[:not(:placeholder-shown)]:opacity-[0.65] motion-reduce:transition-none "
                >
                  Company name
                </label>
              </div>

              <div class="relative mb-3 xl:w-96">
                <FontAwesomeIcon
                  className="flex flex-col"
                  icon={faUser}
                  color="white"
                  height="50px"
                  width="50px"
                />
                <input
                  type="text"
                  class="border  peer m-0 block h-[58px] w-full rounded bg-transparent bg-clip-padding py-4 px-3 text-base font-normal leading-tight text-gray-200 ease-in-out placeholder:text-transparent focus:border-primary focus:bg-white focus:pt-[1.625rem] focus:pb-[0.625rem] focus:text-gray-200 focus:shadow-te-primary focus:outline-none [&:not(:placeholder-shown)]:pt-[1.625rem] [&:not(:placeholder-shown)]:pb-[0.625rem]"
                  id="floatingFullname"
                  placeholder="Full name"
                  name="Fullname"
                  required
                  value={Fullname}
                  onChange={(e) => setFullname(e.target.value)}
                />
                <label
                  for="floatingFullname"
                  class="pointer-events-none absolute top-0 left-0 origin-[0_0] py-4 px-3 text-gray-200 transition-[opacity,_transform] duration-100 ease-in-out peer-focus:translate-x-[0.15rem] peer-focus:-translate-y-2 peer-focus:scale-[0.85] peer-focus:opacity-[0.65] peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:scale-[0.85] peer-[:not(:placeholder-shown)]:opacity-[0.65] motion-reduce:transition-none "
                >
                  Full name
                </label>
              </div>
              <div class=" relative mb-3 mt-2 xl:w-96">
                <FontAwesomeIcon
                  className="flex flex-col"
                  icon={faEnvelope}
                  color="white"
                  height="50px"
                  width="50px"
                />
                <input
                  type="email"
                  class="border border peer m-0 block h-[58px] w-full rounded bg-transparent bg-clip-padding py-4 px-3 text-base font-normal leading-tight text-gray-200 ease-in-out placeholder:text-transparent focus:border-primary focus:bg-white focus:pt-[1.625rem] focus:pb-[0.625rem] focus:text-gray-200 focus:shadow-te-primary focus:outline-none [&:not(:placeholder-shown)]:pt-[1.625rem] [&:not(:placeholder-shown)]:pb-[0.625rem]"
                  id="floatingInput"
                  placeholder="name@example.com"
                  required
                  name="Email"
                  value={Email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <label
                  for="floatingInput"
                  class="pointer-events-none absolute top-0 left-0 origin-[0_0] py-4 px-3 text-gray-200 transition-[opacity,_transform] duration-100 ease-in-out peer-focus:translate-x-[0.15rem] peer-focus:-translate-y-2 peer-focus:scale-[0.85] peer-focus:opacity-[0.65] peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:scale-[0.85] peer-[:not(:placeholder-shown)]:opacity-[0.65] motion-reduce:transition-none "
                >
                  Email address
                </label>
              </div>
              <div class=" relative mb-3 mt-2 xl:w-96">
                <FontAwesomeIcon
                  className="flex flex-col"
                  icon={faPhone}
                  color="white"
                  height="80px"
                  width="50px"
                />
                <input
                  type="phone"
                  class="border border peer m-0 block h-[58px] w-full rounded bg-transparent bg-clip-padding py-4 px-3 text-base font-normal leading-tight text-gray-200 ease-in-out placeholder:text-transparent focus:border-primary focus:bg-white focus:pt-[1.625rem] focus:pb-[0.625rem] focus:text-gray-200 focus:shadow-te-primary focus:outline-none [&:not(:placeholder-shown)]:pt-[1.625rem] [&:not(:placeholder-shown)]:pb-[0.625rem]"
                  id="floatingphone"
                  placeholder="+923000000000"
                  name="Phone"
                  required
                  value={Phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                <label
                  for="floatingphone"
                  class="pointer-events-none absolute top-0 left-0 origin-[0_0] py-4 px-3 text-gray-200 transition-[opacity,_transform] duration-100 ease-in-out peer-focus:translate-x-[0.15rem] peer-focus:-translate-y-2 peer-focus:scale-[0.85] peer-focus:opacity-[0.65] peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:scale-[0.85] peer-[:not(:placeholder-shown)]:opacity-[0.65] motion-reduce:transition-none "
                >
                  Contact Number
                </label>
              </div>
              <div class=" relative mb-3 mt-2 xl:w-96">
                <textarea
                  class="border border-green-500 text-gray-200 peer block min-h-[auto] w-full rounded bg-transparent py-[0.32rem] px-3 leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0"
                  id="exampleFormControlTextarea1"
                  rows="4"
                  placeholder="Your message"
                  name="Message"
                  value={Message}
                  required
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                <label
                  for="exampleFormControlTextarea1"
                  class="pointer-events-none absolute top-0 left-3 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.1] text-gray-200 transition-all duration-200 ease-out peer-focus:-translate-y-[0.9rem] peer-focus:scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.2] motion-reduce:transition-none text-gray-200 "
                >
                  Project details
                </label>
              </div>

              <label
                for="floatingFullname"
                class="block text-gray-200 font-bold"
              >
                Project type
              </label>
              <div class="w-full xl:w-96 btn-group border border-green-500 rounded-sm overflow-hidden flex mt-2 ">
                <input
                  type="radio"
                  class="btn-check"
                  name="custom"
                  value={custom}
                  onChange={(e) => setcustom(e.target.value)}
                  id="option1"
                  autocomplete="off"
                />
                <label
                  class="btn btn-outline-blue hover:bg-blue-500 text-white focus:outline-none focus:shadow-outline-blue active:bg-blue-600"
                  for="option1"
                >
                  Custom Software
                </label>

                <input
                  type="radio"
                  class="btn-check"
                  name="ui"
                  value={ui}
                  onChange={(e) => setui(e.target.value)}
                  id="option2"
                  autocomplete="off"
                />
                <label
                  class="btn btn-outline-blue hover:bg-blue-500 text-white focus:outline-none focus:shadow-outline-blue active:bg-blue-600"
                  for="option2"
                >
                  UI/UX
                </label>

                <input
                  type="radio"
                  class="btn-check"
                  name="consulting"
                  value={consulting}
                  onChange={(e) => setconsulting(e.target.value)}
                  id="option3"
                  autocomplete="off"
                />
                <label
                  class="btn btn-outline-blue hover:bg-blue-500 text-white focus:outline-none focus:shadow-outline-blue active:bg-blue-600"
                  for="option3"
                >
                  Consulting
                </label>
              </div>

              <label
                for="floatinghear"
                class="block text-gray-200 font-bold mt-1"
              >
                How did you hear about us?
              </label>
              <div className="w-full xl:w-96">
                <select
                  required
                  className="border border-gray-200 text-gray-200 py-2 px-3 bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent block w-full"
                >
                  <option value="" hidden selected>
                    Select your option
                  </option>
                  <option
                    onChange={(e) => setrefferal(e.target.value)}
                    value={refferal}
                  >
                    Referral
                  </option>
                  <option
                    onChange={(e) => setMeetup(e.target.value)}
                    value={Meetup}
                  >
                    From a Meetup
                  </option>
                  <option
                    onChange={(e) => setGoogle(e.target.value)}
                    value={Google}
                  >
                    Google Search
                  </option>
                  <option
                    onChange={(e) => setgooglead(e.target.value)}
                    value={googlead}
                  >
                    Google Ad
                  </option>
                  <option
                    onChange={(e) => setfacebook(e.target.value)}
                    value={facebook}
                  >
                    Facebook
                  </option>
                  <option
                    onChange={(e) => setyelp(e.target.value)}
                    value={yelp}
                  >
                    Yelp
                  </option>
                  <option
                    onChange={(e) => setrefferal(e.target.value)}
                    value={blog}
                  >
                    Blog Post
                  </option>
                  <option
                    onChange={(e) => setlinkedIn(e.target.value)}
                    value={LinkedIn}
                  >
                    LinkedIn
                  </option>
                  <option
                    onChange={(e) => settwitter(e.target.value)}
                    value={twitter}
                  >
                    Twitter
                  </option>
                  <option
                    onChange={(e) => setother(e.target.value)}
                    value={Other}
                  >
                    Other
                  </option>
                </select>
              </div>

              <div className="flex flex-col items-center mt-3">
                <button
                  className="animate__animated animate__flash w-40 h-10 bg-gray-600 hover:bg-green-500 rounded-md text-white"
                  style={buttonStyle}
                  type="submit"
                >
                  Submit
                </button>

                <br></br>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className=" bg-black">
        <section class=" text-gray-100">
          <div class="text-center md:max-w-xl lg:max-w-3xl mx-auto">
            <h3 class="text-3xl font-bold mb-6 text-gray-100">
              Words from Our Customers
            </h3>
          </div>

          <div class="grid md:grid-cols-3 gap-6 lg:gap-12 text-center">
            <div class="mb-12 md:mb-0">
              <div class="flex justify-center mb-6">
                {/* <img
                    alt="TEST"
                    src="https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg"
                    class="rounded-full shadow-lg w-32"
                  /> */}
              </div>
              <h5 class="text-xl font-semibold mb-4">Subhan Akhtar</h5>
              <h6 class="font-semibold text-white-600 mb-4">
                Director ,ShowUp
              </h6>
              <p class="mb-4">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="quote-left"
                  class="w-6 pr-2 inline-block"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                  ></path>
                </svg>
                The team at JNY Labs was highly professional and communicative
                throughout the development process, ensuring that all of my
                requirements were met in a timely manner. I appreciated the fact
                that the team was able to offer valuable insights and
                suggestions that helped to improve the app's performance and
                overall appeal.
              </p>
              <ul class="flex justify-center mb-0">
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      alt=""
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star-half-alt"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 536 512"
                  >
                    <path
                      fill="currentColor"
                      d="M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
                    ></path>
                  </svg>
                </li>
              </ul>
            </div>
            <div class="mb-12 md:mb-0">
              <div class="flex justify-center mb-6">
                {/* <img
                    alt=""
                    src="https://mdbootstrap.com/img/Photos/Avatars/img%20(2).jpg"
                    class="rounded-full shadow-lg w-32"
                  /> */}
              </div>
              <h5 class="text-xl font-semibold mb-4">Tilly Smith</h5>
              <h6 class="font-semibold text-white mb-4">CTO ,EasyGhar</h6>

              <p class="mb-4">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="quote-left"
                  class="w-6 pr-2 inline-block"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                  ></path>
                </svg>
                "Working with "JNY Labs" has been an absolute pleasure. Their
                team is always professional, courteous, and knowledgeable. I
                would recommend them to anyone looking for a top-notch IT
                consulting firm."
              </p>
              <ul class="flex justify-center mb-0">
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
              </ul>
            </div>
            <div class="mb-0">
              <div class="flex justify-center mb-6">
                {/* <img
                    alt=""
                    src="https://mdbootstrap.com/img/Photos/Avatars/img%20(9).jpg"
                    class="rounded-full shadow-lg w-32"
                  /> */}
              </div>
              <h5 class="text-xl font-semibold mb-4">Naeem Aslam</h5>
              <h6 class="font-semibold text-white mb-4">CEO ,ZayeCapital</h6>
              <p class="mb-4">
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="quote-left"
                  class="w-6 pr-2 inline-block"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                >
                  <path
                    fill="currentColor"
                    d="M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                  ></path>
                </svg>
                I had the pleasure of working with JNY Labs on the development
                of my trading business website, and I'm happy to report that the
                project was a great success. JNY Labs was clear in their vision
                and goals for the website, and provided me with the 100% scope
                of the assigned project.
              </p>
              <ul class="flex justify-center mb-0">
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="far"
                    data-icon="star"
                    class="w-4 text-yellow-500"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
                    ></path>
                  </svg>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
export default Home;
